import React from "react";
import "../assets/css/card.css";

const EnrollmentNotSucessful = () => {
  return (
    <div className="enrollment-modal-container">
      <div className="enroll-title">
        <h4>Important Update</h4>
        <h4 className="shake">!</h4>
      </div>
      <p style={{ color: "#124070", fontSize: "16px", marginBottom: "15px",padding: "10px"}}>
        Enrollment of bootcamp cohort 1 has officially closed. Don't worry,
        we're already looking forward to Cohort 2! Follow us on our social media
        platforms to stay updated on the launch date and registration details.
        Stay tuned!
      </p>
      <p style={{ color: "#124070", fontSize: "16px", marginBottom: "25px",padding: "10px" }}>
        In the meantime, you can also join our vibrant tech community to learn,
        network, and mingle with like-minded people — absolutely free!
      </p>

      <div style={{ textAlign: "center", marginTop: "20px",padding: "10px" }}>
        <a
          href="https://chat.whatsapp.com/G1SxPH8JAq58JpjupbQGEg"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            backgroundColor: "#124070",
            color: "#fff",
            padding: "12px 25px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "600",
            fontSize: "16px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0b2c5e")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#124070")}
        >
          Join Our Tech Community 
        </a>
      </div>
    </div>
  );
};

export default EnrollmentNotSucessful;
